import React, { Component } from 'react'
export default class ToggleList extends Component<any, any> {
    state = {
        show: false
    }
    toggle = () => {
        this.setState(prevState => ({ show: !prevState.show }))
    }
    render() {
        const { list, title, notFoundTitle } = this.props
        const content = list ? (
            <div>
                <strong style={{ cursor: 'pointer' }} onClick={this.toggle}>
                    {title} | {list.length} (
                    <a style={{ textDecoration: 'underline' }}>{this.state.show ? 'הסתר' : 'הצג'}</a>)
                </strong>
                {!!this.state.show && (
                    <ul>
                        {list.map((item, index) => (
                            <li key={index}>{item.name}</li>
                        ))}
                    </ul>
                )}
            </div>
        ) : (
            notFoundTitle
        )
        return content
    }
}
